module.exports = __webpack_public_path__ + "media/images/illustrations/twinkle_stars-ee025e194b4d553c04ccc7e23f4c8406.svg";